import React from 'react';
import MainLayout from '../../components/layout/MainLayout';
import RateEngineRoutes from './routes';

const RateEngine: React.FC = () => {
  return (
    <MainLayout canProceed={false} showFooter={false}>
      <RateEngineRoutes />
    </MainLayout>
  );
};

export default RateEngine;
